// import React, { useState } from "react";
// import {
//   Container,
//   Grid,
//   Typography,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Button,
//   Box,
//   Card,
//   CardContent,
//   CardHeader,
//   Tabs,
//   Tab,
//   Paper,
//   Divider,
//   Snackbar,
//   Alert,
//   Stack,
// } from "@mui/material";
// import {
//   Person,
//   School,
//   Phone,
//   Email,
//   Home,
//   People,
//   ArrowForward,
//   ArrowBack,
//   CheckCircle,
// } from "@mui/icons-material";

// // Tab Panel component
// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`tabpanel-${index}`}
//       aria-labelledby={`tab-${index}`}
//       {...other}
//       style={{ animation: value === index ? "fadeIn 0.5s" : "none" }}
//     >
//       {value === index && <Box sx={{ p: { xs: 2, sm: 3 } }}>{children}</Box>}
//     </div>
//   );
// }

// function AdmissionEnquiryForm() {
//   const [tabValue, setTabValue] = useState(0);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     middleName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     institute: "",
//     course: "",
//     major: "",
//     previousQualification: "",
//     previousInstitution: "",
//     address: "",
//     parentName: "",
//     parentPhone: "",
//     parentEmail: "",
//     parentOccupation: "",
//     parentAddress: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log(formData);
//     setIsSubmitted(true);
//     setOpenSnackbar(true);
//   };

//   const handleReset = () => {
//     setFormData({
//       firstName: "",
//       middleName: "",
//       lastName: "",
//       email: "",
//       phone: "",
//       institute: "",
//       course: "",
//       major: "",
//       previousQualification: "",
//       previousInstitution: "",
//       address: "",
//       parentName: "",
//       parentPhone: "",
//       parentEmail: "",
//       parentOccupation: "",
//       parentAddress: "",
//     });
//     setIsSubmitted(false);
//   };

//   const colleges = [
//     "Institute of Science",
//     "Secondary Training College",
//     "Elphinstone College",
//     "Sydenham Institute of Management Studies",
//     "Institute of Forensic Science",
//     "Sydenham College of Commerce and Economics",
//   ];

//   const courses = ["B.Sc", "M.Sc", "MMS", "MBA", "B.Ed"];
//   const majors = [
//     "Biotechnology",
//     "Physics",
//     "Psychology",
//     "Management",
//     "Forensics",
//   ];

//   return (
//     <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 6, md: 8 } }}>
//       {/* Header Section */}
//       <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
//         <Typography
//           variant="h3"
//           fontWeight="bold"
//           gutterBottom
//           sx={{
//             background: "linear-gradient(45deg, #6a1b9a, #9c27b0)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             mb: 2,
//             fontSize: { xs: "1.75rem", sm: "2.25rem", md: "3rem" },
//           }}
//         >
//           HBSU Admission Enquiry
//         </Typography>
//         <Typography
//           variant="body1"
//           color="text.secondary"
//           sx={{ 
//             maxWidth: "800px", 
//             mx: "auto",
//             px: 2,
//             lineHeight: 1.6
//           }}
//         >
//           Explore our programmes and submit your inquiry to join our vibrant
//           academic community. Our admissions team will reach out to provide
//           personalized guidance for your educational journey.
//         </Typography>
//       </Box>

//       {/* Success Message or Form */}
//       {isSubmitted ? (
//         <Paper
//           elevation={3}
//           sx={{
//             p: { xs: 3, sm: 4, md: 5 },
//             textAlign: "center",
//             maxWidth: "600px",
//             mx: "auto",
//             backgroundColor: "#f1f8e9",
//             animation: "scaleIn 0.5s ease-out",
//             borderRadius: 2,
//           }}
//         >
//           <CheckCircle 
//             sx={{ 
//               fontSize: { xs: 60, sm: 70, md: 80 }, 
//               color: "success.main", 
//               mb: 2 
//             }} 
//           />
//           <Typography 
//             variant="h4" 
//             color="success.dark" 
//             gutterBottom
//             sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}
//           >
//             Application Submitted!
//           </Typography>
//           <Typography variant="body1" paragraph sx={{ mb: 3 }}>
//             Thank you for your interest in HBSU. Our admissions team will review
//             your application and contact you shortly.
//           </Typography>
//           <Button
//             variant="contained"
//             color="success"
//             onClick={handleReset}
//             sx={{ 
//               mt: 2,
//               px: 3,
//               py: 1,
//               fontWeight: 500
//             }}
//           >
//             Submit Another Enquiry
//           </Button>
//         </Paper>
//       ) : (
//         <Card
//           elevation={4}
//           sx={{
//             borderTop: "6px solid #6a1b9a",
//             borderRadius: 2,
//             overflow: "hidden",
//             animation: "fadeIn 0.8s ease-out",
//             maxWidth: "1100px",
//             mx: "auto",
//           }}
//         >
//           {/* Card Header */}
//           <CardHeader
//             title={
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 <School sx={{ mr: 1.5, color: "#6a1b9a" }} />
//                 <Typography variant="h5" fontWeight="bold">
//                   Student Enquiry Form
//                 </Typography>
//               </Box>
//             }
//             subheader={
//               <Typography variant="subtitle2" sx={{ mt: 1, lineHeight: 1.6, maxWidth: "90%" }}>
//                 Admissions to Sydenham Institute of Management Studies, Research and Entrepreneurship Education (SIMSREE) & Secondary Training College (STC) programmes are conducted through respective MH-CETs.
//               </Typography>
//             }
//             sx={{
//               background:
//                 "linear-gradient(to right, rgba(106, 27, 154, 0.1), rgba(156, 39, 176, 0.05))",
//               pb: 2,
//               pt: 3,
//               px: { xs: 2, sm: 3, md: 4 },
//             }}
//           />

//           {/* Form Content */}
//           <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
//             <Box component="form" onSubmit={handleSubmit} noValidate>
//               {/* Tabs Navigation */}
//               <Paper 
//                 sx={{ 
//                   mb: 3,
//                   borderRadius: 1,
//                   overflow: "hidden",
//                   boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
//                 }}
//               >
//                 <Tabs
//                   value={tabValue}
//                   onChange={handleTabChange}
//                   variant="fullWidth"
//                   sx={{
//                     "& .MuiTabs-indicator": {
//                       backgroundColor: "#6a1b9a",
//                       height: 3,
//                     },
//                     "& .Mui-selected": {
//                       color: "#6a1b9a",
//                       fontWeight: "bold",
//                     },
//                     "& .MuiTab-root": {
//                       py: 1.5,
//                     }
//                   }}
//                 >
//                   <Tab
//                     label={
//                       <Box sx={{ display: "flex", alignItems: "center" }}>
//                         <Person sx={{ mr: 1 }} />
//                         <Typography sx={{ fontWeight: tabValue === 0 ? 600 : 400 }}>
//                           Student Details
//                         </Typography>
//                       </Box>
//                     }
//                     id="tab-0"
//                     aria-controls="tabpanel-0"
//                   />
//                   <Tab
//                     label={
//                       <Box sx={{ display: "flex", alignItems: "center" }}>
//                         <People sx={{ mr: 1 }} />
//                         <Typography sx={{ fontWeight: tabValue === 1 ? 600 : 400 }}>
//                           Parent/Guardian Details
//                         </Typography>
//                       </Box>
//                     }
//                     id="tab-1"
//                     aria-controls="tabpanel-1"
//                   />
//                 </Tabs>
//               </Paper>

//               {/* Student Details Tab */}
//               <TabPanel value={tabValue} index={0}>
//                 <Grid container spacing={3}>
//                   {/* Personal Information */}
//                   <Grid item xs={12}>
//                     <Typography 
//                       variant="subtitle1" 
//                       sx={{ 
//                         fontWeight: 600, 
//                         mb: 1,
//                         color: "text.primary"
//                       }}
//                     >
//                       Personal Information
//                     </Typography>
//                   </Grid>
                  
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="First Name"
//                       name="firstName"
//                       value={formData.firstName}
//                       onChange={handleChange}
//                       className="animate-field"
//                       variant="outlined"
//                       sx={{ mb: { xs: 1, sm: 0 } }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       fullWidth
//                       label="Middle Name"
//                       name="middleName"
//                       value={formData.middleName}
//                       onChange={handleChange}
//                       className="animate-field"
//                       variant="outlined"
//                       sx={{ mb: { xs: 1, sm: 0 } }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Last Name"
//                       name="lastName"
//                       value={formData.lastName}
//                       onChange={handleChange}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Email"
//                       name="email"
//                       type="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       InputProps={{
//                         startAdornment: <Email color="action" sx={{ mr: 1 }} />,
//                       }}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Phone Number"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       helperText="WhatsApp number, if available"
//                       InputProps={{
//                         startAdornment: <Phone color="action" sx={{ mr: 1 }} />,
//                       }}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>

//                   {/* Academic Information Section */}
//                   <Grid item xs={12}>
//                     <Divider sx={{ my: { xs: 2, sm: 3 } }} />
//                     <Typography
//                       variant="subtitle1"
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         color: "#6a1b9a",
//                         fontWeight: 600,
//                         mb: 2,
//                       }}
//                     >
//                       <School sx={{ mr: 1 }} /> Academic Information
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={12} sm={4}>
//                     <FormControl fullWidth required className="animate-field" variant="outlined">
//                       <InputLabel>Institute/College</InputLabel>
//                       <Select
//                         name="institute"
//                         value={formData.institute}
//                         onChange={handleChange}
//                         label="Institute/College"
//                       >
//                         {colleges.map((college, index) => (
//                           <MenuItem key={index} value={college}>
//                             {college}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <FormControl fullWidth required className="animate-field" variant="outlined">
//                       <InputLabel>Course</InputLabel>
//                       <Select
//                         name="course"
//                         value={formData.course}
//                         onChange={handleChange}
//                         label="Course"
//                       >
//                         {courses.map((course, index) => (
//                           <MenuItem key={index} value={course}>
//                             {course}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <FormControl fullWidth required className="animate-field" variant="outlined">
//                       <InputLabel>Major</InputLabel>
//                       <Select
//                         name="major"
//                         value={formData.major}
//                         onChange={handleChange}
//                         label="Major"
//                       >
//                         {majors.map((major, index) => (
//                           <MenuItem key={index} value={major}>
//                             {major}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Previous Qualification"
//                       name="previousQualification"
//                       placeholder="e.g., 12th Science, B.Sc Physics"
//                       value={formData.previousQualification}
//                       onChange={handleChange}
//                       helperText="Completed or currently pursuing"
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Previous Institution"
//                       name="previousInstitution"
//                       placeholder="Name of your previous school/college"
//                       value={formData.previousInstitution}
//                       onChange={handleChange}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>
                  
//                   <Grid item xs={12}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Permanent Address"
//                       name="address"
//                       multiline
//                       rows={3}
//                       placeholder="Your residential address"
//                       value={formData.address}
//                       onChange={handleChange}
//                       InputProps={{
//                         startAdornment: <Home color="action" sx={{ mr: 1, mt: 1 }} />,
//                       }}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>

//                   {/* Navigation Buttons */}
//                   <Grid item xs={12}>
//                     <Box 
//                       sx={{ 
//                         display: "flex", 
//                         justifyContent: "space-between",
//                         mt: { xs: 2, sm: 3 },
//                         gap: 2
//                       }}
//                     >
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={handleReset}
//                         sx={{
//                           borderColor: "rgba(106, 27, 154, 0.5)",
//                           color: "#6a1b9a",
//                           px: 3,
//                         }}
//                       >
//                         Reset
//                       </Button>
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={() => setTabValue(1)}
//                         endIcon={<ArrowForward className="btn-icon" />}
//                         sx={{
//                           bgcolor: "#6a1b9a",
//                           px: 3,
//                           "&:hover": {
//                             bgcolor: "#9c27b0",
//                             "& .btn-icon": {
//                               transform: "translateX(4px)",
//                               transition: "transform 0.3s",
//                             },
//                           },
//                         }}
//                       >
//                         Next
//                       </Button>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </TabPanel>

//               {/* Parent/Guardian Details Tab */}
//               <TabPanel value={tabValue} index={1}>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12}>
//                     <Typography
//                       variant="subtitle1"
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         color: "#6a1b9a",
//                         fontWeight: 600,
//                         mb: 2,
//                       }}
//                     >
//                       <People sx={{ mr: 1 }} /> Parent/Guardian Information
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Parent/Guardian Name"
//                       name="parentName"
//                       value={formData.parentName}
//                       onChange={handleChange}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       required
//                       fullWidth
//                       label="Parent/Guardian Phone"
//                       name="parentPhone"
//                       value={formData.parentPhone}
//                       onChange={handleChange}
//                       InputProps={{
//                         startAdornment: <Phone color="action" sx={{ mr: 1 }} />,
//                       }}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Parent/Guardian Email"
//                       name="parentEmail"
//                       type="email"
//                       value={formData.parentEmail}
//                       onChange={handleChange}
//                       InputProps={{
//                         startAdornment: <Email color="action" sx={{ mr: 1 }} />,
//                       }}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Parent/Guardian Occupation"
//                       name="parentOccupation"
//                       value={formData.parentOccupation}
//                       onChange={handleChange}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Parent/Guardian Address"
//                       name="parentAddress"
//                       multiline
//                       rows={3}
//                       placeholder="Address (if different from student)"
//                       value={formData.parentAddress}
//                       onChange={handleChange}
//                       helperText="Leave blank if same as student address"
//                       InputProps={{
//                         startAdornment: (
//                           <Home color="action" sx={{ mr: 1, mt: 1 }} />
//                         ),
//                       }}
//                       className="animate-field"
//                       variant="outlined"
//                     />
//                   </Grid>

//                   {/* Navigation Buttons */}
//                   <Grid item xs={12}>
//                     <Box 
//                       sx={{ 
//                         display: "flex", 
//                         justifyContent: "space-between",
//                         mt: { xs: 2, sm: 3 },
//                         gap: 2
//                       }}
//                     >
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => setTabValue(0)}
//                         startIcon={<ArrowBack className="btn-icon-back" />}
//                         sx={{
//                           borderColor: "rgba(106, 27, 154, 0.5)",
//                           color: "#6a1b9a",
//                           px: 3,
//                           "&:hover": {
//                             "& .btn-icon-back": {
//                               transform: "translateX(-4px)",
//                               transition: "transform 0.3s",
//                             },
//                           },
//                         }}
//                       >
//                         Back
//                       </Button>
//                       <Button
//                         type="submit"
//                         variant="contained"
//                         color="secondary"
//                         sx={{
//                           bgcolor: "#6a1b9a",
//                           position: "relative",
//                           overflow: "hidden",
//                           px: 3,
//                           "&:hover": {
//                             bgcolor: "#9c27b0",
//                             "&::after": {
//                               transform: "scaleX(1)",
//                             },
//                           },
//                           "&::after": {
//                             content: '""',
//                             position: "absolute",
//                             top: 0,
//                             left: 0,
//                             width: "100%",
//                             height: "100%",
//                             background:
//                               "linear-gradient(45deg, #9c27b0, #6a1b9a)",
//                             transformOrigin: "left",
//                             transform: "scaleX(0)",
//                             transition: "transform 0.3s ease",
//                             zIndex: 0,
//                           },
//                           "& > span": {
//                             zIndex: 1,
//                             position: "relative",
//                           },
//                         }}
//                       >
//                         <span>Submit Enquiry</span>
//                       </Button>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </TabPanel>
//             </Box>
//           </CardContent>

//           {/* Footer Information */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "flex-start",
//               borderTop: "1px solid rgba(0, 0, 0, 0.12)",
//               bgcolor: "rgba(106, 27, 154, 0.05)",
//               px: { xs: 2, sm: 3, md: 4 },
//               py: 3,
//             }}
//           >
//             <Typography variant="subtitle2" fontWeight="medium">
//               For additional information, please contact our admissions office:
//             </Typography>
//             <Stack 
//               direction={{ xs: "column", sm: "row" }} 
//               spacing={{ xs: 1, sm: 4 }}
//               sx={{ mt: 1.5 }}
//             >
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                 <Email fontSize="small" color="action" />
//                 <Typography variant="body2">info@hbsu.ac.in</Typography>
//               </Box>
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                 <Phone fontSize="small" color="action" />
//                 <Typography variant="body2">022-35136751</Typography>
//               </Box>
//             </Stack>
//           </Box>
//         </Card>
//       )}

//       {/* Success Notification */}
//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={6000}
//         onClose={() => setOpenSnackbar(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setOpenSnackbar(false)}
//           severity="success"
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           Your enquiry has been submitted successfully!
//         </Alert>
//       </Snackbar>

//       {/* CSS Animations */}
//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes scaleIn {
//           from {
//             opacity: 0;
//             transform: scale(0.8);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .animate-field {
//           animation: fadeIn 0.5s ease-out;
//         }

//         .animate-field:nth-child(1) {
//           animation-delay: 0.1s;
//         }
//         .animate-field:nth-child(2) {
//           animation-delay: 0.2s;
//         }
//         .animate-field:nth-child(3) {
//           animation-delay: 0.3s;
//         }
//         .animate-field:nth-child(4) {
//           animation-delay: 0.4s;
//         }
//         .animate-field:nth-child(5) {
//           animation-delay: 0.5s;
//         }
//       `}</style>
//     </Container>
//   );
// }

// export default AdmissionEnquiryForm;


"use client"

import { useState } from "react"
import {
  Container,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box,
  Card,
  CardContent,
  CardHeader,
  Tabs,
  Tab,
  Paper,
  Divider,
  Snackbar,
  Alert,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material"
import { Person, School, Phone, Email, Home, People, ArrowForward, ArrowBack, CheckCircle } from "@mui/icons-material"

// Tab Panel component
function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      style={{ animation: value === index ? "fadeIn 0.5s" : "none" }}
    >
      {value === index && <Box sx={{ p: { xs: 2, sm: 3 } }}>{children}</Box>}
    </div>
  )
}

function AdmissionEnquiryForm() {
  const [tabValue, setTabValue] = useState(0)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    institute: "",
    college_course: "",
    course_major: "",
    previous_qualification: "",
    is_completed: true,
    previous_college: "",
    permanent_address: "",
    parent_name: "",
    parent_phone: "",
    parent_email: "",
    parent_address: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)

    try {
      const response = await fetch("https://hsbubackend.tdtlworld.com/formdata/student-enquiry/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`)
      }

      const data = await response.json()
      console.log("Success:", data)

      setIsSubmitted(true)
      setOpenDialog(true)
    } catch (error) {
      console.error("Error:", error)
      setError("Failed to submit the form. Please try again.")
      setOpenSnackbar(true)
    } finally {
      setIsLoading(false)
    }
  }

  const handleReset = () => {
    setFormData({
      first_name: "",
      middle_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      institute: "",
      college_course: "",
      course_major: "",
      previous_qualification: "",
      is_completed: true,
      previous_college: "",
      permanent_address: "",
      parent_name: "",
      parent_phone: "",
      parent_email: "",
      parent_address: "",
    })
    setIsSubmitted(false)
    setOpenDialog(false)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const colleges = [
    "Institute of Science",
    "Secondary Training College",
    "Elphinstone College",
    "Sydenham Institute of Management Studies",
    "Institute of Forensic Science",
    "Sydenham College of Commerce and Economics",
  ]

  const courses = ["B.Sc", "M.Sc", "MMS", "MBA", "B.Ed"]
  const majors = ["Biotechnology", "Physics", "Psychology", "Management", "Forensics", "AI & ML"]

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 6, md: 8 } }}>
      {/* Header Section */}
      <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
        <Typography
          variant="h3"
          fontWeight="bold"
          gutterBottom
          sx={{
            background: "linear-gradient(45deg, #6a1b9a, #9c27b0)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 2,
            fontSize: { xs: "1.75rem", sm: "2.25rem", md: "3rem" },
          }}
        >
          HBSU Admission Enquiry
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            maxWidth: "800px",
            mx: "auto",
            px: 2,
            lineHeight: 1.6,
          }}
        >
          Explore our programmes and submit your inquiry to join our vibrant academic community. Our admissions team
          will reach out to provide personalized guidance for your educational journey.
        </Typography>
      </Box>

      {/* Success Message or Form */}
      {isSubmitted ? (
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 4, md: 5 },
            textAlign: "center",
            maxWidth: "600px",
            mx: "auto",
            backgroundColor: "#f1f8e9",
            animation: "scaleIn 0.5s ease-out",
            borderRadius: 2,
          }}
        >
          <CheckCircle
            sx={{
              fontSize: { xs: 60, sm: 70, md: 80 },
              color: "success.main",
              mb: 2,
            }}
          />
          <Typography variant="h4" color="success.dark" gutterBottom sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}>
            Application Submitted!
          </Typography>
          <Typography variant="body1" paragraph sx={{ mb: 3 }}>
            Thank you for your interest in HBSU. Our admissions team will review your application and contact you
            shortly.
          </Typography>
          <Button
            variant="contained"
            color="success"
            onClick={handleReset}
            sx={{
              mt: 2,
              px: 3,
              py: 1,
              fontWeight: 500,
            }}
          >
            Submit Another Enquiry
          </Button>
        </Paper>
      ) : (
        <Card
          elevation={4}
          sx={{
            borderTop: "6px solid #6a1b9a",
            borderRadius: 2,
            overflow: "hidden",
            animation: "fadeIn 0.8s ease-out",
            maxWidth: "1100px",
            mx: "auto",
          }}
        >
          {/* Card Header */}
          <CardHeader
            title={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <School sx={{ mr: 1.5, color: "#6a1b9a" }} />
                <Typography variant="h5" fontWeight="bold">
                  Student Enquiry Form
                </Typography>
              </Box>
            }
            subheader={
              <Typography variant="subtitle2" sx={{ mt: 1, lineHeight: 1.6, maxWidth: "90%" }}>
                Admissions to Sydenham Institute of Management Studies, Research and Entrepreneurship Education
                (SIMSREE) & Secondary Training College (STC) programmes are conducted through respective MH-CETs.
              </Typography>
            }
            sx={{
              background: "linear-gradient(to right, rgba(106, 27, 154, 0.1), rgba(156, 39, 176, 0.05))",
              pb: 2,
              pt: 3,
              px: { xs: 2, sm: 3, md: 4 },
            }}
          />

          {/* Form Content */}
          <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
            <Box component="form" onSubmit={handleSubmit} noValidate>
              {/* Tabs Navigation */}
              <Paper
                sx={{
                  mb: 3,
                  borderRadius: 1,
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="fullWidth"
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#6a1b9a",
                      height: 3,
                    },
                    "& .Mui-selected": {
                      color: "#6a1b9a",
                      fontWeight: "bold",
                    },
                    "& .MuiTab-root": {
                      py: 1.5,
                    },
                  }}
                >
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Person sx={{ mr: 1 }} />
                        <Typography sx={{ fontWeight: tabValue === 0 ? 600 : 400 }}>Student Details</Typography>
                      </Box>
                    }
                    id="tab-0"
                    aria-controls="tabpanel-0"
                  />
                  <Tab
                    label={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <People sx={{ mr: 1 }} />
                        <Typography sx={{ fontWeight: tabValue === 1 ? 600 : 400 }}>Parent/Guardian Details</Typography>
                      </Box>
                    }
                    id="tab-1"
                    aria-controls="tabpanel-1"
                  />
                </Tabs>
              </Paper>

              {/* Student Details Tab */}
              <TabPanel value={tabValue} index={0}>
                <Grid container spacing={3}>
                  {/* Personal Information */}
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        color: "text.primary",
                      }}
                    >
                      Personal Information
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      required
                      fullWidth
                      label="First Name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      className="animate-field"
                      variant="outlined"
                      sx={{ mb: { xs: 1, sm: 0 } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Middle Name"
                      name="middle_name"
                      value={formData.middle_name}
                      onChange={handleChange}
                      className="animate-field"
                      variant="outlined"
                      sx={{ mb: { xs: 1, sm: 0 } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      required
                      fullWidth
                      label="Last Name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <Email color="action" sx={{ mr: 1 }} />,
                      }}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      label="Phone Number"
                      name="phone_number"
                      value={formData.phone_number}
                      onChange={handleChange}
                      helperText="WhatsApp number, if available"
                      InputProps={{
                        startAdornment: <Phone color="action" sx={{ mr: 1 }} />,
                      }}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>

                  {/* Academic Information Section */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: { xs: 2, sm: 3 } }} />
                    <Typography
                      variant="subtitle1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#6a1b9a",
                        fontWeight: 600,
                        mb: 2,
                      }}
                    >
                      <School sx={{ mr: 1 }} /> Academic Information
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth required className="animate-field" variant="outlined">
                      <InputLabel>Institute/College</InputLabel>
                      <Select
                        name="institute"
                        value={formData.institute}
                        onChange={handleChange}
                        label="Institute/College"
                      >
                        {colleges.map((college, index) => (
                          <MenuItem key={index} value={college}>
                            {college}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth required className="animate-field" variant="outlined">
                      <InputLabel>Course</InputLabel>
                      <Select
                        name="college_course"
                        value={formData.college_course}
                        onChange={handleChange}
                        label="Course"
                      >
                        {courses.map((course, index) => (
                          <MenuItem key={index} value={course}>
                            {course}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth required className="animate-field" variant="outlined">
                      <InputLabel>Major</InputLabel>
                      <Select name="course_major" value={formData.course_major} onChange={handleChange} label="Major">
                        {majors.map((major, index) => (
                          <MenuItem key={index} value={major}>
                            {major}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      label="Previous Qualification"
                      name="previous_qualification"
                      placeholder="e.g., 12th Science, B.Sc Physics"
                      value={formData.previous_qualification}
                      onChange={handleChange}
                      helperText="Completed or currently pursuing"
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      label="Previous Institution"
                      name="previous_college"
                      placeholder="Name of your previous school/college"
                      value={formData.previous_college}
                      onChange={handleChange}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      label="Permanent Address"
                      name="permanent_address"
                      multiline
                      rows={1}
                      placeholder="Your residential address"
                      value={formData.permanent_address}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <Home color="action" sx={{ mr: 1, mt: 1 }} />,
                      }}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>

                  {/* Navigation Buttons */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: { xs: 2, sm: 3 },
                        gap: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={handleReset}
                        sx={{
                          borderColor: "rgba(106, 27, 154, 0.5)",
                          color: "#6a1b9a",
                          px: 3,
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setTabValue(1)}
                        endIcon={<ArrowForward className="btn-icon" />}
                        sx={{
                          bgcolor: "#6a1b9a",
                          px: 3,
                          "&:hover": {
                            bgcolor: "#9c27b0",
                            "& .btn-icon": {
                              transform: "translateX(4px)",
                              transition: "transform 0.3s",
                            },
                          },
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>

              {/* Parent/Guardian Details Tab */}
              <TabPanel value={tabValue} index={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#6a1b9a",
                        fontWeight: 600,
                        mb: 2,
                      }}
                    >
                      <People sx={{ mr: 1 }} /> Parent/Guardian Information
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      label="Parent/Guardian Name"
                      name="parent_name"
                      value={formData.parent_name}
                      onChange={handleChange}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      label="Parent/Guardian Phone"
                      name="parent_phone"
                      value={formData.parent_phone}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <Phone color="action" sx={{ mr: 1 }} />,
                      }}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Parent/Guardian Email"
                      name="parent_email"
                      type="email"
                      value={formData.parent_email}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: <Email color="action" sx={{ mr: 1 }} />,
                      }}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className="animate-field" variant="outlined">
                      <InputLabel>Is Previous Qualification Completed</InputLabel>
                      <Select
                        name="is_completed"
                        value={formData.is_completed}
                        onChange={handleChange}
                        label="Is Previous Qualification Completed"
                      >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      label="Parent/Guardian Address"
                      name="parent_address"
                      multiline
                      rows={1}
                      placeholder="Address (if different from student)"
                      value={formData.parent_address}
                      onChange={handleChange}
                    
                      InputProps={{
                        startAdornment: <Home color="action" sx={{ mr: 1, mt: 1 }} />,
                      }}
                      className="animate-field"
                      variant="outlined"
                    />
                  </Grid>

                  {/* Navigation Buttons */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: { xs: 2, sm: 3 },
                        gap: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => setTabValue(0)}
                        startIcon={<ArrowBack className="btn-icon-back" />}
                        sx={{
                          borderColor: "rgba(106, 27, 154, 0.5)",
                          color: "#6a1b9a",
                          px: 3,
                          "&:hover": {
                            "& .btn-icon-back": {
                              transform: "translateX(-4px)",
                              transition: "transform 0.3s",
                            },
                          },
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="secondary"
                        disabled={isLoading}
                        sx={{
                          bgcolor: "#6a1b9a",
                          position: "relative",
                          overflow: "hidden",
                          px: 3,
                          "&:hover": {
                            bgcolor: "#9c27b0",
                            "&::after": {
                              transform: "scaleX(1)",
                            },
                          },
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "linear-gradient(45deg, #9c27b0, #6a1b9a)",
                            transformOrigin: "left",
                            transform: "scaleX(0)",
                            transition: "transform 0.3s ease",
                            zIndex: 0,
                          },
                          "& > span": {
                            zIndex: 1,
                            position: "relative",
                          },
                        }}
                      >
                        <span>{isLoading ? "Submitting..." : "Submit Enquiry"}</span>
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </CardContent>

          {/* Footer Information */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              borderTop: "1px solid rgba(0, 0, 0, 0.12)",
              bgcolor: "rgba(106, 27, 154, 0.05)",
              px: { xs: 2, sm: 3, md: 4 },
              py: 3,
            }}
          >
            <Typography variant="subtitle2" fontWeight="medium">
              For additional information, please contact our admissions office:
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 1, sm: 4 }} sx={{ mt: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Email fontSize="small" color="action" />
                <Typography variant="body2">info@hbsu.ac.in</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Phone fontSize="small" color="action" />
                <Typography variant="body2">022-35136751</Typography>
              </Box>
            </Stack>
          </Box>
        </Card>
      )}

      {/* Success Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxWidth: "400px",
            p: 1,
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            color: "success.dark",
            pb: 1,
          }}
        >
          <CheckCircle sx={{ mr: 1, color: "success.main" }} />
          {"Enquiry Submitted Successfully!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Thank you for your interest in our programs. Our admissions team will contact you shortly with more
            information.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseDialog} variant="contained" color="success" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Notification */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={error ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {error || "Your enquiry has been submitted successfully!"}
        </Alert>
      </Snackbar>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-field {
          animation: fadeIn 0.5s ease-out;
        }

        .animate-field:nth-child(1) {
          animation-delay: 0.1s;
        }
        .animate-field:nth-child(2) {
          animation-delay: 0.2s;
        }
        .animate-field:nth-child(3) {
          animation-delay: 0.3s;
        }
        .animate-field:nth-child(4) {
          animation-delay: 0.4s;
        }
        .animate-field:nth-child(5) {
          animation-delay: 0.5s;
        }
      `}</style>
    </Container>
  )
}

export default AdmissionEnquiryForm

